module.exports = __webpack_public_path__ + "img/personAccess.a8bf7109.svg";